import { useState } from 'react';
import Sidebar from '../dashboard/components/Sidebar';

const Activity = () => {
  const [filter, setFilter] = useState('all');
  const [searchQuery, setSearchQuery] = useState('');

  const activities = [
    {
      id: 1,
      type: 'project_update',
      title: 'Project Status Updated',
      description: 'Sunset Villa Renovation progress updated to 65%',
      user: 'John Doe',
      timestamp: '2 hours ago',
      icon: 'ri-progress-line',
      color: 'text-blue-600 bg-blue-100',
      project: 'Sunset Villa Renovation'
    },
    {
      id: 2,
      type: 'meeting_scheduled',
      title: 'Meeting Scheduled',
      description: 'Project kickoff meeting with Johnson Family',
      user: 'Sarah Wilson',
      timestamp: '4 hours ago',
      icon: 'ri-calendar-event-line',
      color: 'text-green-600 bg-green-100',
      project: 'Downtown Office Complex'
    },
    {
      id: 3,
      type: 'document_uploaded',
      title: 'Document Uploaded',
      description: 'Architectural plans uploaded for Industrial Warehouse',
      user: 'Mike Chen',
      timestamp: '6 hours ago',
      icon: 'ri-file-upload-line',
      color: 'text-purple-600 bg-purple-100',
      project: 'Industrial Warehouse'
    },
    {
      id: 4,
      type: 'invoice_created',
      title: 'Invoice Created',
      description: 'Invoice #INV-2024-001 created for $15,000',
      user: 'Lisa Rodriguez',
      timestamp: '8 hours ago',
      icon: 'ri-file-text-line',
      color: 'text-orange-600 bg-orange-100',
      project: 'Maple Street Apartments'
    },
    {
      id: 5,
      type: 'client_message',
      title: 'Client Message',
      description: 'New message from TechCorp Inc. about material selection',
      user: 'System',
      timestamp: '1 day ago',
      icon: 'ri-message-line',
      color: 'text-indigo-600 bg-indigo-100',
      project: 'Downtown Office Complex'
    },
    {
      id: 6,
      type: 'task_completed',
      title: 'Task Completed',
      description: 'Site inspection completed for Retail Store Renovation',
      user: 'David Kim',
      timestamp: '1 day ago',
      icon: 'ri-checkbox-circle-line',
      color: 'text-green-600 bg-green-100',
      project: 'Retail Store Renovation'
    },
    {
      id: 7,
      type: 'budget_alert',
      title: 'Budget Alert',
      description: 'Project budget reached 80% for Downtown Office Complex',
      user: 'System',
      timestamp: '2 days ago',
      icon: 'ri-money-dollar-circle-line',
      color: 'text-red-600 bg-red-100',
      project: 'Downtown Office Complex'
    },
    {
      id: 8,
      type: 'lead_added',
      title: 'New Lead Added',
      description: 'New potential client: Wilson Enterprises',
      user: 'Sarah Wilson',
      timestamp: '2 days ago',
      icon: 'ri-user-add-line',
      color: 'text-blue-600 bg-blue-100',
      project: null
    },
    {
      id: 9,
      type: 'project_created',
      title: 'Project Created',
      description: 'New project: Smart Home Installation',
      user: 'John Doe',
      timestamp: '3 days ago',
      icon: 'ri-add-circle-line',
      color: 'text-green-600 bg-green-100',
      project: 'Smart Home Installation'
    },
    {
      id: 10,
      type: 'deadline_approaching',
      title: 'Deadline Approaching',
      description: 'Maple Street Apartments deadline in 3 days',
      user: 'System',
      timestamp: '3 days ago',
      icon: 'ri-alarm-warning-line',
      color: 'text-yellow-600 bg-yellow-100',
      project: 'Maple Street Apartments'
    }
  ];

  const filterOptions = [
    { value: 'all', label: 'All Activities', count: activities.length },
    { value: 'project_update', label: 'Project Updates', count: activities.filter(a => a.type === 'project_update').length },
    { value: 'meeting_scheduled', label: 'Meetings', count: activities.filter(a => a.type === 'meeting_scheduled').length },
    { value: 'document_uploaded', label: 'Documents', count: activities.filter(a => a.type === 'document_uploaded').length },
    { value: 'invoice_created', label: 'Invoices', count: activities.filter(a => a.type === 'invoice_created').length },
    { value: 'client_message', label: 'Messages', count: activities.filter(a => a.type === 'client_message').length },
    { value: 'task_completed', label: 'Tasks', count: activities.filter(a => a.type === 'task_completed').length }
  ];

  const filteredActivities = activities.filter(activity => {
    const matchesFilter = filter === 'all' || activity.type === filter;
    const matchesSearch = searchQuery === '' || 
      activity.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
      activity.description.toLowerCase().includes(searchQuery.toLowerCase()) ||
      (activity.project && activity.project.toLowerCase().includes(searchQuery.toLowerCase()));
    
    return matchesFilter && matchesSearch;
  });

  const handleActivityClick = (activity: any) => {
    if (window.REACT_APP_NAVIGATE) {
      switch (activity.type) {
        case 'project_update':
        case 'budget_alert':
        case 'deadline_approaching':
        case 'project_created':
          window.REACT_APP_NAVIGATE('/projects');
          break;
        case 'meeting_scheduled':
          window.REACT_APP_NAVIGATE('/calendar');
          break;
        case 'document_uploaded':
        case 'invoice_created':
          window.REACT_APP_NAVIGATE('/projects');
          break;
        case 'client_message':
        case 'lead_added':
          window.REACT_APP_NAVIGATE('/leads');
          break;
        case 'task_completed':
          window.REACT_APP_NAVIGATE('/dashboard');
          break;
        default:
          window.REACT_APP_NAVIGATE('/dashboard');
      }
    }
  };

  const getTimeAgo = (timestamp: string) => {
    return timestamp;
  };

  return (
    <div className="flex h-screen bg-gray-50">
      <Sidebar />
      
      <div className="flex-1 flex flex-col overflow-hidden">
        {/* Header */}
        <div className="bg-white border-b border-gray-200 px-6 py-4">
          <div className="flex items-center justify-between">
            <div>
              <h1 className="text-2xl font-bold text-gray-900">Activity Feed</h1>
              <p className="text-sm text-gray-600 mt-1">Track all activities and updates across your projects</p>
            </div>
            
            <div className="flex items-center space-x-4">
              {/* Search */}
              <div className="relative">
                <i className="ri-search-line absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 text-sm"></i>
                <input
                  type="text"
                  placeholder="Search activities..."
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  className="pl-10 pr-4 py-2 w-64 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
                />
              </div>
              
              {/* Export Button */}
              <button className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 text-sm font-medium whitespace-nowrap">
                <i className="ri-download-line mr-2"></i>
                Export
              </button>
            </div>
          </div>
        </div>

        <div className="flex-1 flex overflow-hidden">
          {/* Filters Sidebar */}
          <div className="w-64 bg-white border-r border-gray-200 p-6">
            <h3 className="text-lg font-semibold text-gray-900 mb-4">Filters</h3>
            
            <div className="space-y-2">
              {filterOptions.map((option) => (
                <button
                  key={option.value}
                  onClick={() => setFilter(option.value)}
                  className={`w-full text-left px-3 py-2 rounded-lg text-sm transition-colors ${
                    filter === option.value
                      ? 'bg-blue-100 text-blue-700 font-medium'
                      : 'text-gray-600 hover:bg-gray-100'
                  }`}
                >
                  <div className="flex items-center justify-between">
                    <span>{option.label}</span>
                    <span className={`text-xs px-2 py-1 rounded-full ${
                      filter === option.value
                        ? 'bg-blue-200 text-blue-800'
                        : 'bg-gray-200 text-gray-600'
                    }`}>
                      {option.count}
                    </span>
                  </div>
                </button>
              ))}
            </div>

            {/* Activity Stats */}
            <div className="mt-8 p-4 bg-gray-50 rounded-lg">
              <h4 className="text-sm font-medium text-gray-900 mb-3">Activity Stats</h4>
              <div className="space-y-2 text-sm">
                <div className="flex justify-between">
                  <span className="text-gray-600">Today</span>
                  <span className="font-medium">12</span>
                </div>
                <div className="flex justify-between">
                  <span className="text-gray-600">This Week</span>
                  <span className="font-medium">47</span>
                </div>
                <div className="flex justify-between">
                  <span className="text-gray-600">This Month</span>
                  <span className="font-medium">156</span>
                </div>
              </div>
            </div>
          </div>

          {/* Activity Feed */}
          <div className="flex-1 p-6 overflow-y-auto">
            <div className="max-w-4xl">
              {/* Results Header */}
              <div className="flex items-center justify-between mb-6">
                <div>
                  <h2 className="text-lg font-semibold text-gray-900">
                    {filter === 'all' ? 'All Activities' : filterOptions.find(f => f.value === filter)?.label}
                  </h2>
                  <p className="text-sm text-gray-600">
                    {filteredActivities.length} {filteredActivities.length === 1 ? 'activity' : 'activities'} found
                  </p>
                </div>
                
                <div className="flex items-center space-x-2">
                  <button className="px-3 py-1 text-sm border border-gray-300 rounded-lg hover:bg-gray-50 whitespace-nowrap">
                    <i className="ri-filter-line mr-1"></i>
                    Filter
                  </button>
                  <button className="px-3 py-1 text-sm border border-gray-300 rounded-lg hover:bg-gray-50 whitespace-nowrap">
                    <i className="ri-sort-desc mr-1"></i>
                    Sort
                  </button>
                </div>
              </div>

              {/* Activity List */}
              <div className="space-y-4">
                {filteredActivities.map((activity) => (
                  <div
                    key={activity.id}
                    className="bg-white border border-gray-200 rounded-lg p-6 hover:shadow-md transition-shadow cursor-pointer"
                    onClick={() => handleActivityClick(activity)}
                  >
                    <div className="flex items-start space-x-4">
                      {/* Activity Icon */}
                      <div className={`w-10 h-10 rounded-full flex items-center justify-center ${activity.color}`}>
                        <i className={`${activity.icon} text-lg`}></i>
                      </div>

                      {/* Activity Content */}
                      <div className="flex-1 min-w-0">
                        <div className="flex items-start justify-between">
                          <div className="flex-1">
                            <h3 className="text-lg font-medium text-gray-900 mb-1">
                              {activity.title}
                            </h3>
                            <p className="text-gray-600 mb-2">
                              {activity.description}
                            </p>
                            
                            <div className="flex items-center space-x-4 text-sm text-gray-500">
                              <div className="flex items-center">
                                <i className="ri-user-line mr-1"></i>
                                {activity.user}
                              </div>
                              <div className="flex items-center">
                                <i className="ri-time-line mr-1"></i>
                                {getTimeAgo(activity.timestamp)}
                              </div>
                              {activity.project && (
                                <div className="flex items-center">
                                  <i className="ri-folder-line mr-1"></i>
                                  {activity.project}
                                </div>
                              )}
                            </div>
                          </div>
                          
                          <i className="ri-arrow-right-s-line text-gray-400 text-xl"></i>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>

              {/* Empty State */}
              {filteredActivities.length === 0 && (
                <div className="text-center py-12">
                  <i className="ri-history-line text-4xl text-gray-300 mb-4"></i>
                  <h3 className="text-lg font-medium text-gray-900 mb-2">No activities found</h3>
                  <p className="text-gray-600 mb-4">
                    {searchQuery ? 'Try adjusting your search terms' : 'No activities match the selected filter'}
                  </p>
                  {searchQuery && (
                    <button
                      onClick={() => setSearchQuery('')}
                      className="text-blue-600 hover:text-blue-700 font-medium"
                    >
                      Clear search
                    </button>
                  )}
                </div>
              )}

              {/* Load More */}
              {filteredActivities.length > 0 && (
                <div className="text-center mt-8">
                  <button className="px-6 py-2 border border-gray-300 rounded-lg hover:bg-gray-50 text-sm font-medium whitespace-nowrap">
                    Load More Activities
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Activity;